import {
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";
import plus from "../../assets/images/product/plus.svg";
import TableBrokerDebtDisbursement from "./tableBrokerDebtDisbursement";
import { useBrokerDebtDisbursement } from "../../hooks/useBrokerDebtDisbursement";

export default function BrokerDebtDisbursement() {

  const { isRefetching } = useBrokerDebtDisbursement();

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Bảng ghi thanh toán công nợ chứng chỉ môi giới
          </Text>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableBrokerDebtDisbursement isRefetchingWithCreate={isRefetching} />
      </Box>
    </Box>
  );
}
